import React from 'react';

const LABELS = {
  en: {
    overview: 'Overview',
    ideal_for: 'Who it is for',
    problems: 'Problems addressed',
    deliverables: 'What is included',
    outcomes: 'Typical outcomes',
    pricing: 'Engagement & pricing',
  },
  es: {
    overview: 'Descripción general',
    ideal_for: 'Para quién es',
    problems: 'Problemas que aborda',
    deliverables: 'Qué incluye',
    outcomes: 'Resultados típicos',
    pricing: 'Compromiso y precios',
  },
};

const List = ({ items, testid }) => (
  <ul className="iv2-service-detail-list" data-testid={testid}>
    {items.map((it, idx) => (
      <li key={`${testid}-${idx}`} className="iv2-service-detail-list-item">
        {it}
      </li>
    ))}
  </ul>
);

const ServiceDetailSectionsV2 = ({ service, lang = 'en' }) => {
  if (!service) return null;
  const t = LABELS[lang] || LABELS.en;
  return (
    <section
      className="iv2-service-detail-sections"
      data-testid="iv2-service-detail-sections"
    >
      <div className="iv2-container iv2-service-detail-grid">
        <div className="iv2-service-detail-block" data-block="overview">
          <h2 className="iv2-service-detail-h2">{t.overview}</h2>
          <p className="iv2-service-detail-p" data-testid="iv2-service-detail-overview">
            {service.overview}
          </p>
        </div>

        <div className="iv2-service-detail-block" data-block="ideal_for">
          <h2 className="iv2-service-detail-h2">{t.ideal_for}</h2>
          <p className="iv2-service-detail-p" data-testid="iv2-service-detail-ideal-for">
            {service.ideal_for}
          </p>
        </div>

        <div className="iv2-service-detail-block" data-block="problems">
          <h2 className="iv2-service-detail-h2">{t.problems}</h2>
          <List items={service.problems_addressed} testid="iv2-service-detail-problems" />
        </div>

        <div className="iv2-service-detail-block" data-block="deliverables">
          <h2 className="iv2-service-detail-h2">{t.deliverables}</h2>
          <List items={service.deliverables} testid="iv2-service-detail-deliverables" />
        </div>

        <div className="iv2-service-detail-block" data-block="outcomes">
          <h2 className="iv2-service-detail-h2">{t.outcomes}</h2>
          <List items={service.outcomes} testid="iv2-service-detail-outcomes" />
        </div>

        <div className="iv2-service-detail-block" data-block="pricing">
          <h2 className="iv2-service-detail-h2">{t.pricing}</h2>
          <p className="iv2-service-detail-p" data-testid="iv2-service-detail-pricing">
            {service.pricing}
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServiceDetailSectionsV2;
